const getLastId = (string: string): string | undefined => {
  return string.split('/').pop();
};

export default getLastId;
